import { createContext, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import "./index.css";
import App from "./App.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createClient, SupabaseClient } from "@supabase/supabase-js";
import * as Sentry from "@sentry/react";

export const SupabaseProvider = createContext<SupabaseClient | null>(null);

const queryClient = new QueryClient();

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseKey = import.meta.env.VITE_SUPABASE_KEY || "";
export const supabase = createClient(supabaseUrl, supabaseKey);

Sentry.init({
  dsn: "https://fae295eeba3224c816cecce5e7b7aa3f@o4506427748450304.ingest.us.sentry.io/4509226038394880",
  sendDefaultPii: true,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Suspense fallback="Loading...">
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <SupabaseProvider.Provider value={supabase}>
            <App />
          </SupabaseProvider.Provider>
        </QueryClientProvider>
      </I18nextProvider>
    </Suspense>
  </StrictMode>
);
